import React, { useCallback } from 'react';

import { Theme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ListItemButton from '@mui/material/ListItemButton';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Skeleton from '@mui/material/Skeleton';

import Avatar from '@mui/material/Avatar';

import Typography from '@ts-core/components/Typography';
import TimeAgo from '@ts-core/components/TimeAgo';
import { getStringAvatarText } from '@ts-core/core/utils';

import { Message } from '../../types';

export interface MessageNotificationItemProps {
  message?: Message;
  loading?: boolean;
  selected?: boolean;

  onNotificationClick: (message: Message) => void;
}

const MessageNotificationItem = (props: MessageNotificationItemProps) => {
  const { message, selected = false, loading = false, onNotificationClick } = props;

  const handleNotificationClick = useCallback(() => {
    if (message) {
      onNotificationClick(message);
    }
  }, [message, onNotificationClick]);

  return (
    <>
      <ListItemButton
        disabled={loading}
        alignItems="flex-start"
        onClick={handleNotificationClick}
        sx={(theme: Theme) => ({
          bgcolor: !message?.isRead && !loading ? 'grey.100' : undefined,
        })}
      >
        {selected && <Box position="absolute" left={0} top={0} bottom={0} right={0} width={4} bgcolor="secondary.main" />}
        <ListItemAvatar>
          {loading ? <Skeleton variant="circular" height={40} width={40} /> : <Avatar>{getStringAvatarText(message?.sender.name)}</Avatar>}
        </ListItemAvatar>
        <ListItemText
          disableTypography
          primary={
            <Box display="flex" flexDirection="row" justifyContent="space-between">
              <Typography variant="body1" skeletonProps={{ width: '35%' }} fontWeight={700} loading={loading}>
                {message?.message.title}
              </Typography>
              <Typography variant="caption" skeletonProps={{ width: '25%' }} loading={loading} ml={0.5}>
                <TimeAgo date={message?.message.date} />
              </Typography>
            </Box>
          }
          secondary={
            <Box display="flex" flexDirection="column">
              <Typography noWrap textOverflow="ellipsis" variant="caption" skeletonProps={{ width: '65%' }} loading={loading}>
                {message?.message.content}
              </Typography>
              <Box display="flex" justifyContent="flex-end">
                <Typography mt={0.5} variant="body2" fontWeight={700} skeletonProps={{ width: '30%' }} loading={loading}>
                  {message?.course.name}
                </Typography>
              </Box>
            </Box>
          }
        />
      </ListItemButton>
      <Divider variant="inset" component="li" />
    </>
  );
};

export default MessageNotificationItem;
